export const formatNumber = (value) => {
  const num = Number(value);
  if (isNaN(num)) return 0;
  return num % 1 === 0 ? num : Number(num.toFixed(3));
};

export const formatNumberWithIndianCommas = (value) => {
  const num = Number(value);
  if (!Number.isFinite(num)) return "0";
  return new Intl.NumberFormat("en-IN").format(num);
};
